export default __webpack_public_path__ + "static/media/yt.32fd4982.svg";